import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { injectIntl, defineMessages } from 'react-intl'
import { roles, exerciseUrls, exerciseTypes } from '../../common/config'
import { Button } from '../components'

const LessonButtons = ({ lesson, viewer, addFavoriteLesson, intl }) => (
  <div className="lessons-buttons-box">
    {
      viewer.role === roles.USER &&
      <Link to={`/app/practice/${lesson.id}`}>
        <Button positive>
          {intl.formatMessage(messages.test)}
        </Button>
      </Link>
    }
    {
      !viewer.userLessons.some(l => l.id === lesson.id) &&
      !viewer.userLessons.some(l => l === lesson.id) &&
      !viewer.favoriteLessons.some(l => l === lesson.id) ?
        <Button
          positive
          className="disable-spacing-left"
          onClick={() => addFavoriteLesson(lesson.id)}
        >
          {intl.formatMessage(messages.save)}
        </Button>
      :
        <React.Fragment>
          {
            viewer.role === roles.TEACHER &&
            <React.Fragment>
              <Link to={`/app/create-test/${lesson.id}`}>
                <Button positive className="disable-spacing-left">
                  {intl.formatMessage(messages.createTest)}
                </Button>
              </Link>
              <Link to={`/app/create-homework/${lesson.id}`}>
                <Button positive className="disable-spacing-left">
                  {intl.formatMessage(messages.createHomework)}
                </Button>
              </Link>
            </React.Fragment>
          }
          <Link to={`/app/edit-${exerciseUrls[lesson.type]}/${lesson.id}`}>
            <Button>{intl.formatMessage(messages.edit)}</Button>
          </Link>
        </React.Fragment>
    }
    {
      lesson.type === exerciseTypes.TRANSLATION &&
      <React.Fragment>
        <Link to={`/vocabulary-learn/${lesson.id}`}>
          <Button>{intl.formatMessage(messages.learn)}</Button>
        </Link>
        <Link to={`/memory-game/${lesson.id}`}>
          <Button>{intl.formatMessage(messages.pexeso)}</Button>
        </Link>
      </React.Fragment>
    }
  </div>
)

LessonButtons.propTypes = {
  intl: PropTypes.object.isRequired,
  viewer: PropTypes.object.isRequired,
  lesson: PropTypes.object.isRequired,
  addFavoriteLesson: PropTypes.func.isRequired,
}

const enhance = compose(
  connect(() => ({ }), { }),
  injectIntl,
)

export default enhance(LessonButtons)

const messages = defineMessages({
  test: {
    id: 'lessonsButtons.test',
    defaultMessage: 'Test',
  },
  save: {
    id: 'lessonsButtons.save',
    defaultMessage: 'Uložiť',
  },
  edit: {
    id: 'lessonsButtons.edit',
    defaultMessage: 'Upraviť',
  },
  learn: {
    id: 'lessonsButtons.learn',
    defaultMessage: 'Učiť sa',
  },
  pexeso: {
    id: 'lessonsButtons.pexeso',
    defaultMessage: 'Hrať pexeso',
  },
  createTest: {
    id: 'lessonsButtons.createTest',
    defaultMessage: 'Vytvoriť test',
  },
  createHomework: {
    id: 'lessonsButtons.createHomework',
    defaultMessage: 'Vytvoriť úlohu',
  },
})



// WEBPACK FOOTER //
// ./src/browser/components/LessonButtons.js